import {
  determineAXRuntimeAction,
} from './AXRuntimeActionEngine';

export interface AXRuntimeActionFeed {
  readonly action: 'continue' | 'redirect' | 'deny';
  readonly governor: string;
  readonly reason: string;
  readonly healthy: boolean;
  readonly generatedAt: string;
}

export function getAXRuntimeActionFeed():
AXRuntimeActionFeed {

  const runtime =
    determineAXRuntimeAction();

  return Object.freeze({
    action: runtime.action,
    governor: runtime.governor,
    reason: runtime.reason,
    healthy: runtime.action === 'continue',
    generatedAt: runtime.generatedAt,
  });
}
